import { Box, Container, Stack } from "@mui/material";
import DateRangeSelect from "@entrilia/shared/components/DateRangeSelect";
import SearchField from "@entrilia/shared/components/inputs/SearchField";
import type { DescriptiveDateRange } from "@entrilia/shared/utilities/dateFilterHelper";
import type { InvestorCommunicationCategory } from "../../api/types/investorCommunicationsTypes";
import NewsCategorySelect from "./NewsCategorySelect";
import type { NewsPageState } from "./newsPageState";
import { newsDateRanges } from "./newsPageState";

interface Props {
  categories: InvestorCommunicationCategory[];
  state: NewsPageState;
  onCategoryChange: (categoryExternalId: string | undefined) => void;
  onDateRangeChange: (dateRange: DescriptiveDateRange) => void;
  onSearch: (searchTerm: string) => void;
}

const NewsFilters = ({ categories, state, onCategoryChange, onDateRangeChange, onSearch }: Props) => (
  <Box sx={{ py: 1, bgcolor: "background.paper", borderBottom: 1, borderColor: "divider" }}>
    <Container
      maxWidth="xl"
      sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 2 }}
    >
      <Stack direction="row" spacing={2} useFlexGap sx={{ flexWrap: "wrap" }}>
        <NewsCategorySelect
          categories={categories}
          categoryExternalId={state.categoryExternalId}
          onChange={onCategoryChange}
        />
        <DateRangeSelect predefinedRanges={newsDateRanges} dateRange={state.dateRange} onChange={onDateRangeChange} />
      </Stack>
      <SearchField placeholder="Search news" debounceTimeMs={300} onSearch={onSearch} />
    </Container>
  </Box>
);

export default NewsFilters;
